

export const Objectives = `EmploymentEquity/Objectives`;
export const GetObjectiveYears = Objectives + '/Years';
export const SearchObjectives = Objectives + '/Search';
